// reference 'https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js', 'https://github.com/axios/axios/blob/master/lib/utils.js'
import typeChecker from 'common/typeChecker'
const forEach = (obj, fn) => {
  if (obj === null || typeof obj === 'undefined') {
    return
  }
  if (typeof obj !== 'object') {
    return fn.call(null, obj, 0, obj)
  }
  if (typeChecker.isArray(obj)) {
    for (let i = 0, l = obj.length; i < l; i = i + 1) {
      fn.call(null, obj[i], i, obj)
    }
  } else {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj)
      }
    }
  }
}

const commaEscapeVal = '@:$'
const regExpCommaEscapeVal = /\@:\$/gi
const encode = val => {
  return encodeURIComponent(val)
    .replace(/%40/gi, '@')
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']')
    .replace(/%2C/gi, commaEscapeVal)
}

/*
params = {
   name: ['john','tom','sam']
}
=>
&name=john,tom,sam
 */
export const paramsSerializer = params => {
  const parts = []
  forEach(params, (val, key) => {
    if (val === null || typeof val === 'undefined') {
      return
    }
    if (typeChecker.isArray(val)) {
      const itemsArr = []
      forEach(val, item => {
        if (typeChecker.isDate(item)) {
          itemsArr.push(encode(item.toISOString()))
        } else if (item !== null && typeof item === 'object') {
          itemsArr.push(encode(JSON.stringify(item)))
        } else {
          itemsArr.push(encode(item))
        }
      })
      parts.push(`${encode(key)}=${itemsArr.join(',')}`)
    } else {
      let encodedVal
      if (typeChecker.isDate(val)) {
        encodedVal = encode(val.toISOString())
      } else if (val !== null && typeof val === 'object') {
        encodedVal = encode(JSON.stringify(val))
      } else {
        encodedVal = encode(val)
      }
      parts.push(`${encode(key)}=${encodedVal}`)
    }
  })
  return parts.join('&')
}

/*
&name=john,tom,sam
=>
(ctx.query)
{
   name: ['john','tom','sam']
}
 */
export const paramsDeserializer = async (ctx, next) => {
  ctx['__originqQueryString__'] = ctx.querystring
  ctx.query = paramsDeserialize(ctx.query)
  await next()
}

export const paramsDeserialize = params => {
  const desParams = { ...params }
  for (const key in desParams) {
    if (Object.prototype.hasOwnProperty.call(desParams, key)) {
      if (!desParams[key]) continue
      if (desParams[key].includes(',')) {
        desParams[key] = desParams[key].split(',')
      }
      if (desParams[key].includes(commaEscapeVal)) {
        desParams[key] = desParams[key].replace(regExpCommaEscapeVal, ',')
      }
    }
  }
  return desParams
}
